import React from 'react';
import PropTypes from 'prop-types';

export const FilterContext = React.createContext();

class FilterKeyRoot extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterKey: this.getKeyFromQueryParams(props.location),
    };
    this.getKeyFromQueryParams = this.getKeyFromQueryParams.bind(this);
    this.setFilterKey = this.setFilterKey.bind(this);
  }

  getKeyFromQueryParams(location) {
    const re = /([?&])key=([^&\n]*)/;
    const match = location.search.match(re);
    if (!match) return null;
    return decodeURIComponent(match[2]);
  }

  componentWillMount() {
    this.props.history.listen((location, action) => {
      const filterKey = this.getKeyFromQueryParams(location);
      this.setState((prevState, props) => {
        if (prevState.filterKey === filterKey) return null;
        // todo: keep other params
        return { filterKey };
      });
    });
  }

  setFilterKey(filterKey, pathname) {
    const search = filterKey ? `?key=${filterKey}` : '';
    if (pathname) this.props.history.push({ pathname, search });
    else this.props.history.push({ search });
  }

  render() {
    const { render } = this.props;
    const { filterKey } = this.state;
    return render(filterKey, this.setFilterKey);
  }
}

FilterKeyRoot.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  render: PropTypes.func.isRequired,
};

export default FilterKeyRoot;
